export enum SearchSortAttribute {
    RELEVANCY = "RELEVANCY",
    LAST_MODIFIED_DATE = "LAST_MODIFIED_DATE",
    VIEWS_AND_DOWNLOADS = "VIEWS_AND_DOWNLOADS",
}

export enum ComplianceState {
    COMPLIANT = "COMPLIANT",
    UNSUPPORTED_PAGE_SIZE = "UNSUPPORTED_PAGE_SIZE",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    UNSUPPORTED_PAGE_SIZE_AND_MEDIA_TYPE = "UNSUPPORTED_PAGE_SIZE_AND_MEDIA_TYPE",
    UNSUPPORTED_PPTX = "UNSUPPORTED_PPTX",
    UNSUPPORTED_VIEW = "UNSUPPORTED_VIEW",
}
